<!-- Tools -->
<div class="toolbar toolbar--tools">
  <app-button-group>
  <button
    app-button
    buttonSize="large"
    buttonTheme="light"
    *ngIf="count"
    [matMenuTriggerFor]="selectedMenu">
    <div>
      <span class="text-14 text-bold mr-1">{{ count }}</span>
      <fa-icon icon="angle-up"></fa-icon>
    </div>
    <div class="text-uppercase text-8">Structures</div>
  </button>

  <button 
    app-button
    buttonSize="large"
    buttonTheme="light"
    [selected]="(activeTool$ | async) === toolEnum.Select"
    (click)="toggleTool(toolEnum.Select)">
    <app-button-icon class="text-10" [icon]="toolIcons.Select" [label]="toolEnum.Select"></app-button-icon>
  </button>

  <button 
    app-button
    buttonSize="large"
    buttonTheme="light"
    [selected]="(activeTool$ | async) === toolEnum.Hide"
    (click)="toggleTool(toolEnum.Hide)">
    <app-button-icon class="text-10" [icon]="toolIcons.Hide" [label]="toolEnum.Hide"></app-button-icon>
  </button>

  <button 
    app-button
    buttonSize="large"
    buttonTheme="light"
    [selected]="(activeTool$ | async) === toolEnum.Fade"
    (click)="toggleTool(toolEnum.Fade)">
    <app-button-icon class="text-10" [icon]="toolIcons.Fade" [label]="toolEnum.Fade"></app-button-icon>
  </button>

  <button 
    app-button
    buttonSize="large"
    buttonTheme="light"
    (click)="handleResetClick()">
    <app-button-icon class="text-10" icon="undo" label="Reset"></app-button-icon>
  </button>

  <button 
    app-button
    class="show-sm"
    buttonSize="large"
    buttonTheme="light">
    <app-button-icon class="text-10" icon="bars" label="Menu" [matMenuTriggerFor]="siteMenu"></app-button-icon>
  </button>
</app-button-group>
</div>

<!-- Select Menu -->
<mat-menu #selectedMenu="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="showHideMenu">Show / Hide</button>
  <button mat-menu-item [matMenuTriggerFor]="fadeMenu">Fade</button>
</mat-menu>

<!-- Show / Hide submenu -->
<mat-menu #showHideMenu="matMenu">
  <button mat-menu-item (click)="handleShowSelected()">Show Selected</button>
  <button mat-menu-item (click)="handleHideSelected()">Hide Selected</button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="handleShowInverse()">Show Everything Else</button>
  <button mat-menu-item (click)="handleHideInverse()">Hide Everything Else</button>
</mat-menu>

<!-- Fade submenu -->
<mat-menu #fadeMenu="matMenu">
  <button mat-menu-item (click)="handleFadeSelected()">Fade Selected</button>
  <button mat-menu-item (click)="handleFadeSelected(true)">Fade Everything Else</button>
</mat-menu>

<!-- Tools Menu -->
<mat-menu #toolsMenu="matMenu">
  <button 
    mat-menu-item
    [ngClass]="{'text-bold': (activeTool$ | async) === toolEnum.Select}"
    (click)="toggleTool(toolEnum.Select)">
    <fa-icon [icon]="toolIcons[toolEnum.Select]" class="toolbar-icon"></fa-icon>
    <span class="pr-2">Select</span>
  </button>

  <button 
    mat-menu-item
    [ngClass]="{'text-bold': (activeTool$ | async) === toolEnum.Hide}"
    (click)="toggleTool(toolEnum.Hide)">
    <fa-icon [icon]="toolIcons[toolEnum.Hide]" class="toolbar-icon"></fa-icon>
    <span class="pr-2">Hide</span>
  </button>

  <!-- Fade -->
  <button 
    mat-menu-item
    [ngClass]="{'text-bold': (activeTool$ | async) === toolEnum.Fade}"
    (click)="toggleTool(toolEnum.Fade)">
    <fa-icon [icon]="toolIcons[toolEnum.Fade]" class="toolbar-icon"></fa-icon>
    <span class="pr-2">Fade</span>
  </button>
</mat-menu>

<!-- Site Nav -->
<mat-menu #siteMenu="matMenu">
  <button
    class="menu__item"
    mat-menu-item 
    (click)="handleNavigate('/login')">
    Sign Out
  </button>

  <mat-divider></mat-divider>

  <button
    class="menu__item"
    mat-menu-item 
    (click)="handleHelpClicked()">
    Help
  </button>

  <mat-divider></mat-divider>

  <button
    class="menu__item"
    (click)="handleNavigate('/explore')"
    mat-menu-item>
    Explore
  </button>

  <button
    class="menu__item"
    (click)="handleNavigate('/dashboard')"
    mat-menu-item>
    Dashboard
  </button>